export default __webpack_public_path__ + "static/openinfra-logo-f44519d2cc1ab98411377c71463d371d.png";